import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import SkeletonBlock from 'dpl/common/design_system/SkeletonBlock';
import { makeSequence } from 'dpl/shared/utils';

export default function BreederProfileIntroSectionSkeletonV2({ className }) {
  return (
    <div
      className={classnames(
        'BreederProfileIntroSectionSkeletonV2 container-xxl pb8',
        className
      )}
    >
      <div className="nt6 nh6">
        <div className="aspect-ratio aspect-ratio--6x5 relative mb8">
          <div className="aspect-ratio--object">
            <SkeletonBlock height="100%" width="100%" />
          </div>
        </div>
      </div>

      <div>
        <SkeletonBlock className="font-28 mb5" height="1em" width="6em" />
        <div className="flex flex-column gap-8 mb2">
          {makeSequence(6).map(index => (
            <SkeletonBlock key={index} className="font-16" height="1em" />
          ))}
        </div>
        <ul className="flex flex-column gap-24 bg-gray-100 pv8 ph5 mt8 nh6">
          {makeSequence(4).map(index => (
            <li key={index}>
              <div className="flex gap-16">
                <SkeletonBlock
                  key={index}
                  className="br2"
                  height="32px"
                  width="32px"
                />
                <div className="flex-auto">
                  <SkeletonBlock
                    className="font-16 fw-medium lh-title mb1"
                    height="1em"
                  />
                  <SkeletonBlock
                    className="font-16 fw-medium lh-title mb1"
                    height="1em"
                  />
                  <SkeletonBlock
                    className="font-14 fw-medium lh-title"
                    height="1em"
                    width="75%"
                  />
                </div>
              </div>
            </li>
          ))}
        </ul>
        <SkeletonBlock className="font-24 mt8 mb4" height="1em" width="8em" />
        <ul className="flex flex-column gap-24 mt8">
          {makeSequence(4).map(index => (
            <li key={index}>
              <div className="flex-auto">
                <SkeletonBlock
                  className="font-16 fw-medium lh-title mb4"
                  height="1em"
                  width="16em"
                />
                <SkeletonBlock
                  className="font-14 fw-medium lh-title mb1"
                  height="1em"
                />
                {index % 2 === 0 && (
                  <SkeletonBlock
                    className="font-14 fw-medium lh-title mb1"
                    height="1em"
                  />
                )}
                <SkeletonBlock
                  className="font-14 fw-medium lh-title"
                  height="1em"
                  width="90%"
                />
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

BreederProfileIntroSectionSkeletonV2.propTypes = {
  className: PropTypes.string
};

BreederProfileIntroSectionSkeletonV2.defaultProps = {
  className: null
};
